export const IS_CREATE_CATEGORY = "IS_CREATE_CATEGORY";
export const IS_UPDATE_CATEGORY = "IS_UPDATE_CATEGORY";
export const CATEGORY_LIST = "CATEGORY_LIST";
export const CATEGORY_LIST_META = "CATEGORY_LIST_META";
export const IS_CATEGORY_LIST_LOADING = "IS_CATEGORY_LIST_LOADING";
export const IS_CATEGORY_STATUS_UPDATING = "IS_CATEGORY_STATUS_UPDATING";
export const AFTER_CREATED = "AFTER_CREATED";
export const AFTER_UPDATED = "AFTER_UPDATED";
export const AFTER_DELETED = "AFTER_DELETED";
export const CAT_IMG = "CAT_IMG";
export const IS_IMG_LOADING = "IS_IMG_LOADING";
export const CAT_ICON = "CAT_ICON";
export const IS_ICON_LOADING = "IS_ICON_LOADING";
export const CAT_HOVER_ICON = "CAT_HOVER_ICON";
export const IS_HOVER_ICON_LOADING = "IS_HOVER_ICON_LOADING";
